const STORE_INITIALISATION = 'STORE_INITIALISATION';

export { STORE_INITIALISATION };
